import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    services: null
  },
  mutations: {
    updateServices (state, data) {
      state.services = data
    }
  },
  actions: {
    async initializeServices ({ dispatch, state }) {
      await Vue.http.get(process.env.BASE_URL + 'services.json').then(
        response => {
          if (response && response.data && response.data.services) {
            state.services = response.data.services
            dispatch('refreshServices')
          }
        }, () => {
          console.log('Error: could not load services.json')
        }
      )
    },
    async refreshServices ({ commit, state }) {
      if (state.services == null || state.services.length < 1) {
        return
      }

      let newServices = []
      for (var i = 0; i < state.services.length; i++) {
        let newService = state.services[i]

        if (state.services[i].healthUrl) {
          await Vue.http.get(state.services[i].healthUrl)
            .then(response => {
              newService.healthStatus = true
            }, () => {
              newService.healthStatus = false
            })
        }
        newServices.push(newService)
      }
      commit('updateServices', newServices)
    }
  }
})
